import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center_flex_layout" }
const _hoisted_2 = {
  id: "qrcode",
  ref: "qrcode"
}
const _hoisted_3 = {
  class: "center_flex_layout",
  style: {"flex":"1"}
}

import { reactive, ref, Ref, onMounted } from "vue";
import QRCode from "qrcodejs2";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'TestCreateCode',
  setup(__props) {

const router = useRouter();

const createCode = () => {
  new QRCode("qrcode", {
    width: 200,
    height: 200,
    text: "https://api.sancttech.com/?state=857970000337",
  });
  // router.push('/payingFail');
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, null, 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: createCode
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交生成二维码")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})